/**
 * Checks whether a feature is enabled or not by looking for a class on the HTML tag
 * (similar to Modernizr). Used for CSS/JavaScript based feature switching.
 * @class
 */
function FeatureService() {
    const classes = document.documentElement.className.split(/\s+/);
    this._features = {};

    for (let i = 0; i < classes.length; i++) {
        this._features[classes[i]] = true;
    }
}

FeatureService.prototype.isEnabled = function (featureName) {
    return featureName in this._features && this._features[featureName];
};

FeatureService.prototype.setFeature = function (featureName, isEnabled) {
    this._features[featureName] = isEnabled;
};

/* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
FeatureService.prototype.features = {
    checkout: 'conversational-checkout-wizard',
    sfExpandPersonalShopperComment: 'sf-expand-personal-shopper-comment',
    mfExpandPersonalShopperComment: 'mf-expand-personal-shopper-comment',
    lfExpandPersonalShopperComment: 'lf-expand-personal-shopper-comment',
    checkoutPerformanceEnhancements: 'checkout-performance-enhancements',
    clickAndCollectStoreSearch: 'click-and-collect-store-search',
    enableDiscoverLandingPage: 'enable-discover-landing-page',
    enableGetEdrPointsBalanceOnLogin: 'enable-get-edr-points-balance-on-login',
    recipeSocialMedia: 'recipe-social-media',
    recipePrintExport: 'recipe-export-print',
    rememberMe: 'remember-me-enabled',
    checkoutWithPaypal: 'enable-checkout-with-paypal',
    enableCustomCouponPromotionSuccessMessage: 'enable-custom-coupon-promotion-success-message',
    showAcceptedCardsInCheckout: 'show-accepted-cards-in-checkout',
    wos4048: 'wos4048',
    enableMyInvoicesPage: 'enable-my-invoices-page',
    enableRichRelevanceRecommendations: 'enable-rich-relevance-recommendations',
    // following features are used to determine which page groups have RR placements
    // enabled. Naming convention 'rr-show-placements-in-{pagegroup}-pages' is
    // expected by the RR instrumentation components.
    rrShowPlacementsInCategoryPages: 'rr-show-placements-in-category-pages',
    rrShowPlacementsInHomepagePages: 'rr-show-placements-in-homepage-pages',
    rrShowPlacementsInHyfPages: 'rr-show-placements-in-hyf-pages',
    rrShowPlacementsInreorderPages: 'rr-show-placements-in-reorder-pages',
    rrShowPlacementsInSpecialsGroupPages: 'rr-show-placements-in-specials-group-pages',

    /* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
};

module.exports = FeatureService;

// Provided for backwards compat with code in Behaviour.js and Shop.js
// Delete once no longer needed
if (!('wowFeatures' in window)) {
    window.wowFeatures = new FeatureService();
}



// WEBPACK FOOTER //
// ./src/common/feature/feature.service.js